import React from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';
import UserTooling from '../../../tooling/userTooling';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import FormatTooling from '../../../tooling/formatTooling';
import Constants from '../../../definitions/constants';

import GlassPopup from '../common/interface/glassPopup';
import TextBox from '../common/inputs/textBox';
import CheckBox from '../common/inputs/checkBox';
import Select from '../common/inputs/select';
import ErrorFeedback from '../common/feedback/errorFeedback';
import EntityMetricsInputs from '../common/entity/entityMetricsInputs';

const FormPopup = props => {
  const {
    handleShowPopup,
    handleOnChangeForm,
    handleButton,
    loadingButton,
    fullLoading,
    metricsStatus,
    metricsOptionsLists,
    statusButton,
    formData,
    errors,
    entityNameSingular,
    popupState
  } = props;
  return (
    <GlassPopup
      className="form_popup"
      title={(<FormattedMessage 
         id={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"group.id") ? "common.entity.editEntity" : "common.entity.createEntity"}
         values={{entityNameSingular: entityNameSingular}}
       />)}
      buttonText={(<FormattedMessage 
         id={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"group.id") ? "common.entity.editEntity" : "common.entity.createEntity"}
         values={{entityNameSingular: entityNameSingular}}
       />)}
      type={Constants.interface.popup.types.LATERAL}
      {...props}
    >
      <ErrorFeedback
        status={statusButton}
        fieldErrors={errors}
        localesFieldsPath="groupAdmin.fields"
      />
      <TextBox 
        styleType={Constants.interface.inputs.styleType.OUTLINED}
        type={Constants.interface.inputs.type.TEXT}
        id="name"
        data-path="group.name"
        value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"group.name")}
        onChange={handleOnChangeForm}
        labelLocale={<FormattedMessage id="groupAdmin.fields.name"/>}
        className={("name" in errors) ? "has_error" : null}
      />
      {JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"group.id") && (
        <CheckBox 
          id="active"
          data-path="group.active"
          value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"group.active")}
          onChange={handleOnChangeForm}
          labelLocale={<FormattedMessage id="common.entity.fields.active"/>}
        />
      )}
      <EntityMetricsInputs
        metricsStatus={metricsStatus}
        formData={formData}
        metricsOptionsLists={metricsOptionsLists}
        handleOnChangeForm={handleOnChangeForm}
      />
    </GlassPopup>
  );
};

export default FormPopup;



// WEBPACK FOOTER //
// ./source/client/components/groupAdmin/formPopup.jsx